import React from 'react'
import './index.css'
interface ContactItemProps {
    avatar?: string
    nickname?: string
    className?: string
}
const ContactItem: React.FC<ContactItemProps> = (props) => {
    return (
        <span className={`object-item ${props.className || ''}`}>
            <img className='object-avatar' src={props.avatar} alt='icon' />
            <span className='object-nickname single-ell'>{props.nickname}</span>
        </span>
    )
}

export default ContactItem
